export const createGaPush = (global = window) => {
  if (global.dataLayer === undefined) {
    // @TODO provide a "capped" array in order to prevent uncontrolled growth in case GA is not in place
    global.dataLayer = [];
  }
  return (event: any) => {
    global.dataLayer.push(event);
  }
}
